import type { SVGProps } from 'react';

const SvgDeleteLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7 5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7H7V5Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path
      d='M6 7H18V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V7Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path d='M4 7H20' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10 11V16' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M14 11V16' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgDeleteLt;
